import { trackerGet, trackerPatch, trackerPost } from '../client';
import type { DomainCreate, DomainUpdate, PageResult, TrackerDomain } from '../types';

export function listDomains(params: {
  page?: number;
  page_size?: number;
  group_id?: number;
} = {}) {
  return trackerGet<PageResult<TrackerDomain>>('/domains', params);
}

export function createDomain(body: DomainCreate) {
  return trackerPost<TrackerDomain>('/domains', body);
}

export function updateDomain(id: number, body: DomainUpdate) {
  return trackerPatch<TrackerDomain>(`/domains/${id}`, body);
}

export function checkDomainDns(id: number) {
  return trackerPost<TrackerDomain>(`/domains/${id}/check-dns`, {});
}

export function checkAllDomainsDns() {
  return trackerPost<{ server_ip: string; checked: number; items: TrackerDomain[] }>(
    '/domains/check-dns',
    {},
  );
}
